require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./dancing-to-its-my-house-as-boxman.json") })
        }
      }, "path---dancing-to-its-my-house-as-boxman");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---dancing-to-its-my-house-as-boxman!./.cache/json/dancing-to-its-my-house-as-boxman.json
// module id = 506
// module chunks = 231608221292675